module.exports = __webpack_public_path__ + "static/media/ddselect.d1af2f07.svg";